import { styled } from 'linaria/react';
import { media } from '../../../../../media';

export const OtherCategoriesSection = styled.section`
	width: 100%;
	max-height: max-content;
	margin-top: 80px;
	overflow: hidden;
	background-color: var(--background-secondary);
	padding-block: 80px;
	${media.laptop} {
		padding-block: 40px;
	}
	${media.tablet} {
		padding-block: 54px;
	}
	${media.mobile} {
		padding-block: 32px;
	}
`;

export const Wrapper = styled.div`
	${media.tablet} {
		width: 100vw;
		overflow-y: scroll;
		-ms-overflow-style: none; /* IE and Edge */
		scrollbar-width: none; /* Firefox */
		margin-inline: -54px;
		&::-webkit-scrollbar {
			display: none;
		}
	}
	${media.mobile} {
		width: 100%;
		margin-inline: 0;
	}
`;
export const OtherCategoriesSlider = styled.div`
	display: flex;
	flex-direction: row;
	width: max-content;
	height: 180px;
	margin-top: 24px;
	column-gap: 24px;
	& a {
		width: 216px;
		${media.laptop} {
			width: 169px;
		}
		${media.tablet} {
			width: 180px;
		}
		${media.mobile} {
			width: 100%;
		}
	}

	${media.tablet} {
		padding-inline: 54px;
	}
	${media.mobile} {
		flex-direction: column;
		width: 100%;
		height: max-content;
		margin-top: 16px;
		row-gap: 16px;
		padding-inline: 0;
	}
`;
